import {Component, OnInit} from '@angular/core';
import {MatSnackBar} from '@angular/material';
import {UploadService} from '../../../services/upload.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GuidesService} from '../../../services/guides.service';
import {LanguageService} from '../../../services/language.service';
import {OrganizationsService} from '../../../services/organizations.service';
import {TagService} from '../../../services/tag.service';
import {UtilsService} from '../../../services/utils.service';
import {DistrictsService} from '../../../services/districts.service';


declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-guide-view',
  templateUrl: './guide-view.component.html',
  styleUrls: ['./guide-view.component.scss']
})
export class GuideViewComponent implements OnInit {

  selectedFiles: FileList;

  // latest fields

  selectedGuideId;

  guide: any = {originallyFrom: {}, dob: null, languages: [], tags: [], organizations: [], districts: [], specializations: [], trekking: [], hobbies: [], awards: [], certifications: [], publications: [], featured_in: []};
  availableSpecializations = [];
  availableTreks = [];
  allLanguages = [];
  allOrganizations = [];
  allDistricts = [];
  allTags = [];
  allGenders = [];
  allTypes = [];
  allEducationsTypes = [];

  constructor(public snackBar: MatSnackBar, private uploadService: UploadService,
              private route: ActivatedRoute, private guidesService: GuidesService, private languageService: LanguageService,
              private organizationsService: OrganizationsService, private tagService: TagService,
              private utilsService: UtilsService, private districtsService: DistrictsService,
              private router: Router) {
    route.params.subscribe(params => {
      if (params['id']) {
        this.selectedGuideId = params['id'];

        this.guidesService.getGuideMetaData().subscribe(result => {
          if (result && result.data) {
            this.availableSpecializations = JSON.parse(JSON.stringify(result.data['availableSpecializations']));
            this.availableTreks = JSON.parse(JSON.stringify(result.data['availableTreks']));
            this.allGenders = result.data['availableGenders'];
            this.allTypes = result.data['availableTypes'];
            this.allEducationsTypes = result.data['availableEducationType'];
          }
        });

        this.languageService.list().subscribe(result => {
          if (result && result.data && result.data['languages']) {
            this.allLanguages = result.data['languages'].edges ? result.data['languages'].edges.map(e => e.node) : result.data['languages'];
          }
        });

        this.organizationsService.list().subscribe(result => {
          if (result && result.data && result.data['organizations']) {
            this.allOrganizations = result.data['organizations'].edges ? result.data['organizations'].edges.map(e => e.node) : result.data['organizations'];
          }
        });

        this.tagService.list().subscribe(result => {
          if (result && result.data && result.data['tags']) {
            this.allTags = result.data['tags'].edges ? result.data['tags'].edges.map(e => e.node) : result.data['tags'];
          }
        });

        this.districtsService.getAllDistricts().subscribe(result => {
          if (result && result.data && result.data['districts']) {
            const raw = result.data['districts'];
            this.allDistricts = Array.isArray(raw) ? raw : (raw.edges ? raw.edges.map(e => e.node) : []);
          }
        }, err => {
          console.error('Failed to load districts', err);
          this.allDistricts = [];
        });

        this.guidesService.getGuide(this.selectedGuideId).subscribe(result => {
          if (result && result.data) {
            this.guide = JSON.parse(JSON.stringify(result.data['guide']));
            if (!this.guide.originallyFrom || !this.guide.originallyFrom['id']) {
              this.guide['originallyFrom'] = {};
            }

            if (!this.guide.specializations) this.guide.specializations = [];
            if (!this.guide.trekking) this.guide.trekking = [];
            if (!this.guide.languages) this.guide.languages = [];
            if (!this.guide.tags) this.guide.tags = [];
            if (!this.guide.organizations) this.guide.organizations = [];
            if (!this.guide.districts) this.guide.districts = [];

            this.guide.hobbies = this.guide.hobbies || [];
            this.guide.awards = this.guide.awards || [];
            this.guide.certifications = this.guide.certifications || [];
            this.guide.publications = this.guide.publications || [];
            this.guide.featured_in = this.guide.featured_in || [];

            this.updateCheckedProp(this.availableSpecializations, 'specializations');
            this.updateCheckedProp(this.availableTreks, 'trekking');
          }
        });
      }
    });
  }

  ngOnInit() {

  }

  updateGuide() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.guide['name']);
    if (requiredSuccess) {
      this.guide.hobbies = (this.guide.hobbies || []).filter(v => v && v.trim());
      this.guide.awards = (this.guide.awards || []).filter(v => v && v.trim());
      this.guide.certifications = (this.guide.certifications || []).filter(v => v && v.trim());
      this.guide.publications = (this.guide.publications || []).filter(v => v && v.title && v.title.trim());
      this.guide.featured_in = (this.guide.featured_in || []).filter(v => v && v.title && v.title.trim());

      this.guidesService.updateGuide(this.guide).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Guide Updated !!', '');
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update Guide.', '');
        console.log('there was an error sending the query', error);
      });
    }

  }

  openSnackBar(message: string, action: string) {
    //noinspection TypeScriptValidateTypes
    this.snackBar.open(message, action, {duration: 3000});
  }

  deleteGuide() {
    const cd = $('#confirm-delete');
    UIkit.modal(cd).hide();
    this.openSnackBar('Deleting guide', '');
    setTimeout(function () {
      cd.remove();
    }, 500);


  }

  updateCheckedProp(arr, prop) {
    if (arr) {
      arr.forEach(obj => {
        if (this.guide[prop].indexOf(obj.key) > -1) {
          obj.checked = true;
        }
      });
    }
  }

  updateSpecialization(currentSpec) {
    if (!this.guide.specializations) {
      this.guide.specializations = [];
    }
    if (currentSpec.checked) {
      this.guide.specializations.push(currentSpec.key);
    } else {
      const index = this.guide.specializations.indexOf(currentSpec.key);
      if (index !== -1) {
        this.guide.specializations.splice(index, 1);
      }
    }
    this.updateGuide();
  }

  updateTreks(currentTrek) {
    if (!this.guide.trekking) {
      this.guide.trekking = [];
    }
    if (currentTrek.checked) {
      this.guide.trekking.push(currentTrek.key);
    } else {
      const index = this.guide.trekking.indexOf(currentTrek.key);
      if (index !== -1) {
        this.guide.trekking.splice(index, 1);
      }
    }
    this.updateGuide();
  }

  isPhoto(mimetype) {
    return mimetype.indexOf('image') > -1;
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  upload() {
    const file = this.selectedFiles.item(0);
    this.uploadService.uploadfile(file, function (err, data) {
      if (err) {
        console.log('There was an error uploading your file: ', err);
        return false;
      }

      console.log('Successfully uploaded file.', data);
    });
  }

  hasItem(list: any[], id: string): boolean {
    if (!list) return false;
    return list.some(item => (item && item.id === id) || item === id);
  }

  toggleItem(list: any[], item: any, event: any) {
    if (!list) return;
    const checked = event.target.checked;
    const index = list.findIndex(i => (i && i.id === item.id) || i === item.id);
    if (checked && index === -1) {
      list.push(item);
    } else if (!checked && index !== -1) {
      list.splice(index, 1);
    }
  }

  // ── Dynamic list helpers ─────────────────────────────────────────
  addItem(list: any[], defaultValue: any = '') {
    list.push(defaultValue);
  }

  removeItem(list: any[], index: number) {
    list.splice(index, 1);
  }

  trackByIndex(index: number): number {
    return index;
  }

  changeHeadshot(file, bool) {
    if (bool === true) {
      delete this.guide['headshot'];
    } else {
      this.guide['headshot'] = {
        id: file.id
      };
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/guides/guide-view/guide-view.component.ts